import { render } from "./Error.vue?vue&type=template&id=6e5ad128"
const script = {}

import "./Error.vue?vue&type=style&index=0&id=6e5ad128&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__